import { queryClient } from '../../../../v4/migration/queryClientSingleton';
import { myReduxProxy } from 'v5/api/_common/reduxProxy.connected';
import { myEnterpriseFeatureFlagApi } from '../../../api/enterprise-feature-flag/enterprise-feature-flag.api.connected';
import { createEnterpriseFeatureFlagService } from './EnterpriseFeatureFlagService.impl';

export const myEnterpriseFeatureFlagService =
  createEnterpriseFeatureFlagService({
    api: myEnterpriseFeatureFlagApi,
    queryClient,
    reduxProxy: myReduxProxy
  });
